import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MitsPDFViewerComponent } from './mits-pdf-viewer.component';

@NgModule({
  imports: [CommonModule],
  declarations: [MitsPDFViewerComponent],
  entryComponents: [MitsPDFViewerComponent],
  exports: [MitsPDFViewerComponent],
  providers: [],
})
export class MitsPDFViewerModule {}
